import SubLabel from "components/Atoms/Sublabel";
import React from "react";
import MultiPickerListWithSelectedItems from "../MultiPickerListWithSelectedItems";
import { MultiPickerListProps } from "../props";

const MultiContactList = (props: MultiPickerListProps<server.dto.ContactSmallV2>) => {
  const [instruction, setInstruction] = React.useState<server.dto.PaginatedContactInstruction>({
    page: 1,
    perPage: 20,
    keyword: "",
  });

  return <>
    <MultiPickerListWithSelectedItems
      instruction={instruction}
      onInstructionChange={i => setInstruction(i)}
      queryKey="contactpickerlist"
      api={window.CoreApi.Contact.PaginatedSmall}

      getError={() => undefined}
      excludeKeys={props.excludeKeys}
      renderListItem={contact => <div>
        <div>{contact.name.fullName}</div>
        <SubLabel>{contact.position}</SubLabel>
      </div>}

      onChange={props.onChange}
      getId={(contact) => contact.contactId}
      getLabel={contact => <div>{contact.name.fullName}</div>}
      value={props.value}
    />
  </>;
};

export default MultiContactList;